import React, { Component } from "react";
import axios from "axios";

import { SegmentedItem, TableItemDinamico, dineroDisabledMask, ButtonItem, RangePickerItem } from "../../../Components/Items";
import { Tooltip, message, PageHeader, Tag, Popconfirm } from "antd";
import { connect } from "react-redux";
import { CloseCircleOutlined, EyeOutlined, FileSearchOutlined, MailOutlined } from "@ant-design/icons";
import moment from "moment";
import ModalFacturasRelacionadas from "./ModalFacturasRelacionadas/ModalFacturasRelacionadas";
import VistaPrevia from "../ArchivosXml/VistaPrevia/VistaPrevia";
import SolicitarComplemento from "./SolicitarComplemento/SolicitarComplemento";
//import MandarCorreoPagos from "./MandarCorreoPagos/MandarCorreoPagos";

class PagosCompras extends Component {
    tableRef = null;
    state = {
        todasPagos: [],
        loading: false,
        totalRecords: 0,
        valor: 0,
        modalVerComplemento: false,
        modalVerComplementoId: null,
        modalVerPago: false,
        modalVerPagoId: null,
        isFacturasModalVisible: false,
        selectedFacturasIds: [],
        fechaInicio: null,
        fechaFin: null,
        modalVistaPrevia: false,
        modalVistaPreviaId: null,
        modalSolicitar: false,
        modalSolicitarPagoId: null,
    }

    consultarPagos = (params) => {
        this.setState({ loading: true });

        axios
            .post(
                "pagos/selectPagosCompra",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasPagos:
                            res.data.data.map(value => {
                                return {
                                    ...value,
                                    fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                                    tieneComplemento: !!value.xmlDescargadoId,
                                    xmlId: value.xmlDescargadoId || null,
                                    xmlComplementoUUID: value.xmlComplementoUUID || null,
                                    accion: { _id: value._id, estado: value.estado, facturasIds: value.facturasPagadasIds, tieneComplemento: !!value.xmlDescargadoId, xmlId: value.xmlDescargadoId || null },
                                }
                            }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false
                    });
                } else {
                    this.setState({ todasPagos: [], loading: false, totalRecords: 0 });
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar los Pagos");
                console.log(err);
            });
    }

    handleCancelarPago = (id) => {
        this.setState({ loading: true });
        axios.post("pagos/cancelarPago", { pagoId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken }).then(res => {
            if (res.data.success === 2) {
                message.success("Pago cancelado correctamente");
                if (this.tableRef) {
                    this.tableRef.fetchData();
                }
            } else {
                message.error("Error al cancelar el Pago");
            }
            this.setState({ loading: false });
        }).catch(err => {
            message.error("Error al cancelar el Pago");
            console.log(err);
            this.setState({ loading: false });
        });
    }

    //Funciones para el modal de ver facturas relacionadas
    verFacturasModal = (facturasIds, pagoId) => {
        this.setState({
            isFacturasModalVisible: true,
            selectedFacturasIds: facturasIds,
            modalVerPagoId: pagoId,
        });
    };

    cerrarFacturasModal = () => {
        this.setState({
            isFacturasModalVisible: false,
            selectedFacturasIds: [],
            modalVerPagoId: null,
        });
    };


    render() {
        const columns = [
            /*{
                title: "Folio",
                dataIndex: "folio",
                key: "folio",
                buscar: 'folio',
                width: 100,
            },
                */

            {
                title: "Proveedor",
                dataIndex: "proveedor",
                key: "proveedor",
                width: 170,
                buscar: 'proveedor',
                ellipsis: true,
            },
            {
                title: "Documentos pagados",
                dataIndex: "documentosPagados",
                key: "documentosPagados",
                buscar: 'documentosPagados',
                width: 80,
                align: "center",
            },
            {
                title: "Fecha",
                dataIndex: "fechaPago",
                key: "fechaPago",
                defaultSortOrder: 'descend',
                sorter: true,
                render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
                width: 100,
                ellipsis: true,
                align: "center",
            },
            {
                title: "Banco",
                dataIndex: "banco",
                key: "banco",
                align: "center",
                width: 120,
                ellipsis: true,
                buscar: true,
            },
            {
                title: "Forma de Pago",
                dataIndex: "formaDePago",
                key: "formaDePago",
                align: "center",
                width: 120,
                ellipsis: true,
            },
            {
                title: "Monto",
                dataIndex: "monto",
                key: "monto",
                sorter: true,
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.monto)}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                buscar: "monto",
                width: 120,
                ellipsis: true,
                align: "right",
            },
            {
                title: "Moneda",
                dataIndex: "moneda",
                key: "moneda",
                buscar: "moneda",
                responsive: [],
                width: 0,
            },

            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                responsive: ["md"],
                render: (value, record) => {
                    if (value === 0) {
                        return <Tag color="red" className="square-tag">Cancelado</Tag>;
                    }
                    if (value === 1) {
                        return <Tag color="green" className="square-tag">Vigente</Tag>;
                    }

                },
                width: 110,
                ellipsis: true,
            },
            {
                title: "Complemento",
                dataIndex: "accion",
                key: "complemento",
                align: "center",
                width: 110,
                render: (value) => value.tieneComplemento
                    ? <Tag color="green" className="square-tag">Con Rep</Tag>
                    : <Tag color="gold" className="square-tag">Sin Rep</Tag>,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                align: "center",
                fixed: window.innerWidth > 1200 ? "right" : null,
                width: 150,
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, record) => {
                    let buttons = [];

                    const puedeVerFacturas = value.facturasIds.length > 0;
                    buttons.push(
                        <Tooltip key={`ver`} title={puedeVerFacturas ? "Ver Facturas" : "No hay facturas"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                onClick={() => puedeVerFacturas && this.verFacturasModal(value.facturasIds, value._id)}
                                disabled={!puedeVerFacturas}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    buttons.push(
                        <Tooltip key={`xml`} title={value.tieneComplemento ? "Ver complemento XML" : "Sin complemento relacionado"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                olivo
                                icon={<FileSearchOutlined />}
                                onClick={() => value.tieneComplemento && this.setState({ modalVistaPrevia: true, modalVistaPreviaId: value.xmlId })}
                                disabled={!value.tieneComplemento}
                            />
                        </Tooltip>
                    );

                    const puedeSolicitar = !value.tieneComplemento && value.estado !== 0 && this.props.permisoSolicitarComplemento;
                    buttons.push(
                        <Tooltip key={`solicitar`} title={puedeSolicitar ? "Solicitar complemento al proveedor" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                naranja
                                icon={<MailOutlined />}
                                onClick={() => puedeSolicitar && this.setState({ modalSolicitar: true, modalSolicitarPagoId: value._id })}
                                disabled={!puedeSolicitar}
                            />
                        </Tooltip>
                    );

                    const puedeCancelarPago = record.estado !== 0 && !record.contado && !record.pagarFactura
                    buttons.push(
                        <Popconfirm
                            key={`cancelar-${value._id}`}
                            title={"Seguro que desea cancelar este pago?"}
                            onConfirm={() => this.handleCancelarPago(value._id)}
                            okText="Si"
                            cancelText="No"
                            disabled={!puedeCancelarPago}
                        >
                            <Tooltip title={puedeCancelarPago ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    rojo
                                    icon={<CloseCircleOutlined />}
                                    disabled={!puedeCancelarPago}
                                >
                                </ButtonItem>
                            </Tooltip>
                        </Popconfirm>
                    )

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];
        return (
            <>
                <PageHeader
                    title="Pagos Compras"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            <RangePickerItem
                                value={[
                                    this.state.fechaInicio ? moment(this.state.fechaInicio) : null,
                                    this.state.fechaFin ? moment(this.state.fechaFin) : null,
                                ]}
                                allowClear
                                onChange={(dates) => {
                                    const fechaInicio = dates?.[0] ? dates[0].startOf("day").toISOString() : null;
                                    const fechaFin = dates?.[1] ? dates[1].endOf("day").toISOString() : null;
                                    this.setState({ fechaInicio, fechaFin });
                                    if (this.tableRef) {
                                        this.tableRef.updateExternalFilters({
                                            valor: this.state.valor,
                                            fechaInicio,
                                            fechaFin,
                                        });
                                    }
                                }}
                                style={{ marginRight: 8 }}
                            />
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Todos', value: 0 }, { label: 'Vigentes', value: 1 }, { label: 'Canceladas', value: 2 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({
                                                valor: value,
                                                fechaInicio: this.state.fechaInicio,
                                                fechaFin: this.state.fechaFin,
                                            });
                                        }
                                        this.setState({ valor: value });
                                    }}

                                    value={this.state.valor}
                                />
                            }
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    /*onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/verPagos", { id: record._id });
                            },
                        };
                    }}*/
                    anadirValorFiltro={this.state.valor}
                    onClearFilters={() => this.setState({ fechaInicio: null, fechaFin: null })}
                    onFetchData={this.consultarPagos.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasPagos}
                    columns={columns}
                    filterStorageKey={"PagosComprasFiltrosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={0}
                />
                <ModalFacturasRelacionadas
                    visible={this.state.isFacturasModalVisible}
                    onClose={this.cerrarFacturasModal}
                    facturasIds={this.state.selectedFacturasIds}
                    pagoId={this.state.modalVerPagoId}
                    history={this.props.history} // Pasa el historial para la navegación
                />
                <VistaPrevia
                    visible={this.state.modalVistaPrevia}
                    id={this.state.modalVistaPreviaId}
                    cerrarVistaPrevia={() => this.setState({ modalVistaPrevia: false, modalVistaPreviaId: null })}
                />
                <SolicitarComplemento
                    visible={this.state.modalSolicitar}
                    id={this.state.modalSolicitarPagoId}
                    cerrarSolicitarComplemento={() => this.setState({ modalSolicitar: false, modalSolicitarPagoId: null })}
                />
            </>
        );



    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturaGlobal:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
            )?.activado,
        permisoSolicitarComplemento:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6a45b582bf9af164bc4f65bd"
            )?.activado,
    };
};

export default connect(mapStateToProps)(PagosCompras);